'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typingAgentTimeoutsForThreadInProps = undefined;

var _immutable = require('immutable');

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _threadFromProps = require('../../threads/selectors/threadFromProps');

var _agentTypingStates = require('./agentTypingStates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typingAgentTimeoutsForThreadInProps = exports.typingAgentTimeoutsForThreadInProps = (0, _reselect.createSelector)([_threadFromProps.threadFromProps, _agentTypingStates.agentTypingStates], function (thread, agentTypingStates) {
  var threadId = (0, _threadGetters.getThreadId)(thread);

  return (0, _get2.default)('' + threadId, agentTypingStates) || (0, _immutable.Map)();
});


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/selectors/typingAgentTimeoutsForThreadInProps.js
// module id = 636
// module chunks = 2 3